import React, { useEffect, useState } from "react";
import "./CountReport.css";
import Invoices from "../../api/Invoice";



const CountReport = () => {
    let sum = 0;
    const [todaysSum, setTodaysSum] = useState(0);
    useEffect(() => {
        const HandleReq = async () => {
            const data = await Invoices.get('/get-todays-invoice');
            const data_array = [];

            for (let i = 0; i < (data.data).length; i++) {
                // eslint-disable-next-line
                sum = sum + data.data[i].quantity;
                data_array.push(data.data[i].quantity);
            }
            setTodaysSum(sum);
        }
        HandleReq();
    }, [setTodaysSum]);
    return <div className="count-main-report">
        <div className="report-title">
            TODAY'S  <br />SALE :
        </div>
        <div>
            <span className="count-report">{todaysSum}</span>
        </div>
    </div>

}

export default CountReport;